import ViewProductsHistoryForm from "./ViewProductsHistoryForm";

export default ViewProductsHistoryForm;
